var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-card-item",class:{ 'c-card-item--border': _vm.border },on:{"click":function($event){$event.stopPropagation();return _vm.goToReport(_vm.item)}}},[_c('div',{staticClass:"c-card-item--title"},[_vm._v(_vm._s(_vm.item.title))]),_c('div',{staticClass:"c-card-item--content"},[(_vm.item.rating)?_c('span',{staticClass:"rate",class:{
				'up': _vm.item.rateType === 1,
				'down': _vm.item.rateType === 2
			}},[_vm._v(" "+_vm._s(_vm.item.rating)+" ")]):_vm._e(),_c('span',{staticClass:"info"},[_vm._v(_vm._s(_vm.item.orgName)+" · "+_vm._s(_vm.item.publishDate))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }